import { render, staticRenderFns } from "./MainModeFlashCardBook.vue?vue&type=template&id=14766f4b&"
import script from "@/scripts/MainMode/MainModeCourse/MainModeFlashCardLanding/components/MainModeFlashCardBook.js?vue&type=script&lang=js&"
export * from "@/scripts/MainMode/MainModeCourse/MainModeFlashCardLanding/components/MainModeFlashCardBook.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports